import { render, staticRenderFns } from "./CategorySearch.vue?vue&type=template&id=c0a13350&"
import script from "./CategorySearch.vue?vue&type=script&lang=js&"
export * from "./CategorySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports